import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { toUnicode } from 'punycode';
import { isBloggerBusiness } from '../../../../../utils/accessService';
import { addProtocol } from '../../../../../utils/addProtocol';
import { analyticsService, EventSource } from '../../../../../utils/analyticsService';
import { IconArrowDiagonalRight } from '../../../../icon/IconArrowDiagonalRight';
import { IconWebsite } from '../../../../icon/IconWebsite';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { ProfileSiteProps } from './types';

export const ProfileSite = ({ business }: ProfileSiteProps) => {
    const isBlogger = isBloggerBusiness(business.type);
    const url = business.links?.shortSite;
    const siteText = url || business.links?.siteDisplay;
    const decodedSiteText = siteText && toUnicode(siteText);

    const onClickOutClick = useCallback(() => {
        analyticsService.trackClickOut({
            businessId: business.id,
            clickoutUrl: business.links?.site,
            eventSource: EventSource.BUSINESS,
            target: 'business_site',
        });
    }, [business]);

    if (isBlogger || !decodedSiteText || !url) {
        return null;
    }

    return (
        <Flex
            as={Link}
            target="_blank"
            rel="nofollow noreferrer"
            direction="row"
            alignItems="center"
            textDecoration="none"
            userSelect="none"
            to={addProtocol(url)}
            spacing={1}
            onClick={onClickOutClick}
            py={1}
            pr={2}
        >
            <IconWebsite fontSize={16} color="var(--color-primary)" />
            <Typography variant="body" color="primary" weight="medium">
                {decodedSiteText}
            </Typography>
            <IconArrowDiagonalRight fontSize={16} color="var(--color-primary)" />
        </Flex>
    );
};
